import React, { Component } from "react";
import Desplegable from "../../desplegable";
import FormDatosDeceso from "../formularios/form_deceso";
import VistaDatosDeceso from "../vistas/vista_deceso";

export default class DesplegableDeceso extends Component {
  render() {
    return (
      <Desplegable
        eventKey="8"
        id="8"
        Toogle={"Datos Fallecimiento"}
        showModal={this.props.state.showModalMatrix[8]}
        handleButtonShow={this.props.handleButtonShow}
        Text={<VistaDatosDeceso DatosMonja={this.props.state.DatosUsuario}></VistaDatosDeceso>}
        Form={
          <FormDatosDeceso
            DatosMonja={this.props.state.DatosUsuario}
            setDatosHermana={this.props.setDatosHermana}
            handleButtonShow={this.props.handleButtonShow}
            setAlert={this.props.setAlert}
            ErrorHandling={this.props.ErrorHandling}
          ></FormDatosDeceso>
        }
        canEdit={true}
      />
    );
  }
}
